import React from 'react';
import { motion } from 'framer-motion';

export const LoadingAnimation = () => {
  return (
    <div className="flex items-center justify-center min-h-[400px] relative">
      <div className="relative">
        {/* Bolt */}
        <motion.div
          className="w-16 h-16 bg-indigo-500 rounded-lg"
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 10, -10, 0],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            className="w-full h-full p-3 text-white"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 3L4 14H12L11 21L20 10H12L13 3Z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </motion.div>

        {/* Background blur effect */}
        <motion.div
          className="absolute inset-0 bg-indigo-100 rounded-lg -z-10 blur-xl"
          animate={{
            scale: [1, 1.5, 1],
            opacity: [0.5, 0.8, 0.5],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      </div>
      
      {/* Loading text */}
      <motion.div 
        className="absolute bottom-0 left-1/2 -translate-x-1/2 text-lg text-indigo-600 font-medium"
        animate={{ opacity: [0.5, 1] }}
        transition={{
          duration: 1,
          repeat: Infinity,
          repeatType: "reverse",
        }}
      >
        Loading JLS Apps...
      </motion.div>
    </div>
  );
};
